import React from "react";

import BipononGrayIcon from "../icons/biponon-gray.svg";
import MerchantNameIcon from "../icons/name.svg";
import bKashGrayIcon from "../icons/bKash-gray.svg";
import AddressIcon from "../icons/location.svg";
import AvatarIcon from "../icons/avatar.svg";
import HomeIcon from "../icons/home.svg";
import SearchImage from "../images/Search.png";

const MerchantDetailsCard = ({
  wallet_number,
  merchant_name,
  shop_address,
  merchant_full_name,
  registration_date,
  product_type,
  bmcc_code,
  bmcc_name,
  assigned_mdo_name,
  assigned_mdo_number,
  assigned_mdo_id,
  assigned_mdo_image,
  assigned_mdo_age,
  merchant_age,
  loading = false,
  error = false,
  errorMessage = "",
}) => {
  const merchantDetails = [
    { label: "Name", value: merchant_name, icon: MerchantNameIcon },
    {
      label: "bKash Wallet Number",
      value: wallet_number,
      icon: bKashGrayIcon,
    },
    {
      label: "Detailed Address",
      value: shop_address,
      icon: AddressIcon,
    },
    {
      label: "Shop Owner",
      value: merchant_full_name || "N/A",
      subValue: wallet_number,
      icon: AvatarIcon,
    },
    {
      label: "Registration Date",
      value: registration_date || "N/A",
      subValue: merchant_age,
      icon: AvatarIcon,
    },
    {
      label: "Product Type",
      value: product_type || "N/A",
      icon: BipononGrayIcon,
    },
    {
      label: "BMCC",
      value: bmcc_code || "N/A",
      subValue: bmcc_name,
      icon: HomeIcon,
    },
  ];

  if (loading) {
    return (
      <div className="card-section" style={{ flex: 1 }}>
        <h3 className="card-section__title">Merchant Details</h3>
        {[...Array(7)].map((_, index) => (
          <div className="icon-details-item" key={index}>
            <div className="skeleton skeleton-icon"></div>
            <div className="icon-details-text">
              <div className="skeleton skeleton-text skeleton-text--small"></div>
              <div className="skeleton skeleton-text skeleton-text--medium"></div>
            </div>
          </div>
        ))}
        <div className="icon-details-item">
          <div className="skeleton skeleton-icon"></div>
          <div className="icon-details-text">
            <div className="skeleton skeleton-text skeleton-text--small"></div>
            <div className="mao-info">
              <div className="skeleton skeleton-avatar"></div>
              <div className="text-info">
                <div className="skeleton skeleton-text skeleton-text--small"></div>
                <div className="skeleton skeleton-text skeleton-text--medium"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card-section" style={{ flex: 1 }}>
        <h3 className="card-section__title">Merchant Details</h3>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">Error Fetching Data</h4>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="card-section"
      style={{
        flex: 1,
      }}
    >
      <h3 className="card-section__title">Merchant Details</h3>
      {merchantDetails.map((item, index) => (
        <div className="icon-details-item" key={index}>
          <img
            src={item.icon}
            alt={`${item.label} icon`}
            className="details-icon"
          />
          <div className="icon-details-text">
            <span className="label">{item.label}</span>
            <span className="value">{item.value}</span>
            {item.subValue && <span className="sub-text">{item.subValue}</span>}
          </div>
        </div>
      ))}
      <div className="icon-details-item">
        <img src={HomeIcon} alt="Assigned MDO icon" className="details-icon" />
        <div className="icon-details-text">
          <span className="label">Assigned MDO</span>
          <div className="mao-info">
            <div className="avatar">
              <img
                src={assigned_mdo_image || AvatarIcon}
                alt="MDO Avatar"
                className="mao-avatar-image"
              />
            </div>
            <div className="text-info">
              <div className="label">{assigned_mdo_name || "N/A"}</div>
              <div className="value">{assigned_mdo_number || "N/A"}</div>
              {assigned_mdo_age && (
                <div className="sub-text">{assigned_mdo_age || "N/A"}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantDetailsCard;
